"use client";

import { useEffect, useState } from "react";
import styles from "../event-info.module.css";
import { useGetEvent } from "../../../../lib/util";
import CartModal from "../../../../components/event/CartModal";
import { getTimeFormatted } from "../../../../components/common/TimeFormat";
import ImageComponent from "../../../../components/common/ImageComponent";
import InitialCard from "../../../../components/common/InitialCard";
import { users, timeIcon, mapIcon25 } from "../../../../assets";
import { useModalManager } from "../../../../components/modal/useModalManager";

export default function EventInfo({ data }) {
  const [isClient, setIsClient] = useState(false);

  const [event, setEvent] = useState(data.event || {});
  const { modal, closeModal, modalBackButton, openModal } = useModalManager();

  const { isLoading, mutate } = useGetEvent({
    onError: (response) => {
      setError(response.message);
    },
    onSuccess: async (response) => {
      const { event } = response.data;
      setEvent(event);
      openModal();
    },
  });

  const modalHandler = () => {
    mutate({ eventId: data.event.eventId });
  };

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) {
    return null;
  }

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.topsection}>
            <div>
              <h1>{data.event.name}</h1>
              <div className={styles.hashtags}>
                {data.event.tags.map((a, i) => {
                  return <div key={i}>{`# ${a}`}</div>;
                })}
              </div>
              <div className={styles.host}>
                <InitialCard
                  image={data.event.host.image}
                  name={data.event.host.name}
                />
                {data.event.host.name}
              </div>
            </div>
            <div className={styles.details}>
              <div>
                <h2>When and where</h2>
                <div className={styles.detailsgrid}>
                  <div>
                    <div className={styles.iconWrapper}>{timeIcon}</div>
                    <div>
                      <h3>Date and time</h3>
                      <div>{getTimeFormatted(data.event.startDate)}</div>
                    </div>
                  </div>
                  <div>
                    <div className={styles.iconWrapper}>{users}</div>
                    <div>
                      <h3>Attendees</h3>
                      <div>
                        {data.event.totalAttendees
                          ? data.event.totalAttendees
                          : "No attendees yet"}
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.detailsgrid}>
                  <div>
                    <div className={styles.iconWrapper}>{mapIcon25}</div>
                    <div>
                      <h3>Location</h3>
                      <div>{data.event.address}</div>
                    </div>
                  </div>
                  <div>
                    <div className={styles.mapWrapper}>
                      {data.event.mapUrl && (
                        <ImageComponent
                          className={styles.locationImage}
                          src={data.event.mapUrl.replace(
                            "r200x200",
                            "r1500x1500"
                          )}
                          alt="map image"
                          style={{
                            objectfit: "cover",
                          }}
                          width={354}
                          quality={100}
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div>
                  <h2>About this event</h2>
                  <div
                    className={styles.about}
                    style={{ whiteSpace: "pre-line" }}
                  >
                    {data.event.description}
                  </div>
                </div>
              </div>
              <div>
                <h3>Tickets</h3>
                <div className={styles.ticketWrapper}>
                  {data.event.bundles.map((ticket) => (
                    <div className={styles.ticket} key={ticket._id}>
                      <div className={styles.left}>
                        <div className={styles.title}>{ticket.name}</div>
                        {ticket.paidBundle && (
                          <div className={styles.amount}>{`${
                            data.event.currency
                          }${ticket.amount.toLocaleString()}`}</div>
                        )}
                      </div>

                      {!ticket.paidBundle && (
                        <div
                          className={`${styles.pricing} ${
                            !ticket.paidBundle && styles.free
                          }`}
                        >
                          <svg
                            width="9"
                            height="8"
                            viewBox="0 0 9 8"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle cx="4.5" cy="4" r="3" fill="#0E86D4" />
                          </svg>

                          {ticket.paidBundle ? "Paid" : "Free"}
                        </div>
                      )}
                    </div>
                  ))}
                  <button onClick={modalHandler} disabled={isLoading}>
                    {isLoading ? "Processing..." : "Buy Ticket"}
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* <SimilarTrending
            eventTags={tagsCase(data?.event?.tags || [])}
            eventId={data.event.eventId}
          /> */}
        </div>
      </div>
      {modal && (
        <CartModal
          closeModal={closeModal}
          event={event}
          modalBackButton={modalBackButton}
        />
      )}
    </>
  );
}
